import { useMemo } from 'react'
import { t } from 'ttag'
import { useQuery } from 'react-query'

import { api } from '@h2/api'
import { Select } from '@h2/components/inputs/select'

const LessonSelect = ({ ...rest }) => {
  const { data, isLoading } = useQuery('lessons', () => {
    return api.fetch('/admin/lessons/list', { version: 'v1', method: 'POST', body: {} })
  })
  const lessons = useMemo(() => {
    if (isLoading) {
      return []
    }

    return data.lessons.map(lesson => ({ value: lesson.id, label: lesson.name }))
  }, [data, isLoading])

  if (isLoading) {
    return null
  }

  return (
    <Select id="lessonSelect" items={lessons} placeholder={t`Your Lessons`} {...rest} />
  )
}

export { LessonSelect }
